import { must } from "@/common/utils/must";
import * as analytics from "@/modules/analytics";

export const shareTypes = {
  FACEBOOK: "facebook",
  TWITTER: "twitter",
  PINTEREST: "pintterest",
  EMAIL: "email",
};

export function popup(url: string, windowName?: string) {
  const newwindow = window.open(url, windowName, "height=400,width=400");
  if (window.focus as (() => void) | undefined) {
    must(newwindow, "popup window").focus();
  }
  return false;
}

export function shareFacebook(link: string) {
  analytics.track("Share", { pix_target: "facebook" });
  popup(
    "https://www.facebook.com/dialog/share?app_id=165959330468212&display=popup&href=" +
      encodeURI(link) +
      "&redirect_uri=https%3A%2F%2Fpixmoto.com%2F",
  );
}

export function shareEmail(link: string) {
  analytics.track("Share", { pix_target: "email" });
  window.location.href = `mailto:?subject=Have%20a%20look&body=${encodeURI(link)}`;
}

export function shareTwitter(link: string) {
  analytics.track("Share", { pix_target: "twitter" });
  popup(`https://twitter.com/intent/tweet?url=${encodeURI(link)}`);
}

export function sharePinterest(link: string) {
  analytics.track("Share", { pix_target: "pinterest" });
  must(window.PinUtils, "window.PinUtils").pinOne({
    url: link,
  });
}
